module.exports = __webpack_public_path__ + "img/Frame2077@2x.72793846.png";